import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElTooltip } from 'element-plus';

// Props with defaults

export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    content: {},
    placement: { default: 'defeault' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTooltip), {
    "popper-class": "tooltip",
    effect: "dark",
    content: _ctx.content,
    placement: (_ctx.placement as any)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["content", "placement"]))
}
}

})